'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _slIcon_blank = require('../../img/icon/sl-icon_blank.svg');

var _slIcon_blank2 = _interopRequireDefault(_slIcon_blank);

var _SLDummy = require('../../img/SL-Dummy.jpg');

var _SLDummy2 = _interopRequireDefault(_SLDummy);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formStep = require('../../container/steps/formStep');

var _formStep2 = _interopRequireDefault(_formStep);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactSpinkit = require('react-spinkit');

var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _currency = require('../../currency');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ServiceOverlay = function ServiceOverlay(props) {
  var imageUrl = props.service.ImageId ? _config2.default.getKey("imageUrl") + props.service.ImageId : _SLDummy2.default;
  return _react2.default.createElement('div', {
    className: 'overlay'
  }, _react2.default.createElement('div', null, _react2.default.createElement('div', null, 'Angebotsbeschreibung:'), _react2.default.createElement('div', null, _react2.default.createElement('img', {
    src: imageUrl
  })), _react2.default.createElement('div', null, _react2.default.createElement('p', {
    className: 'name'
  }, props.service.Name), _react2.default.createElement('p', null, _react2.default.createElement('span', null, _react2.default.createElement('span', {
    className: 'price'
  }, props.hidePrices ? "" : props.service.Price > 0 ? (0, _currency.currencyConverter)(props.service.Price) : "Preis auf Anfrage"), _react2.default.createElement('small', null, props.hidePrices ? "" : "inkl. Mwst./ Montage / Material"))), _react2.default.createElement('p', {
    dangerouslySetInnerHTML: {
      __html: props.service.Description
    }
  })), _react2.default.createElement('div', null, _react2.default.createElement('a', {
    className: 'link ico close',
    onClick: props.onClose
  }, 'Fenster schlie\xDFen'))));
};

ServiceOverlay.propTypes = {
  service: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired
};

var ServiceQuestionElement = function (_React$Component) {
  _inherits(ServiceQuestionElement, _React$Component);

  function ServiceQuestionElement(props) {
    _classCallCheck(this, ServiceQuestionElement);

    var _this = _possibleConstructorReturn(this, (ServiceQuestionElement.__proto__ || Object.getPrototypeOf(ServiceQuestionElement)).call(this, props));

    _this.id = _underscore2.default.uniqueId("service-question-");
    _this.onAnswer = _this.onAnswer.bind(_this);
    return _this;
  }

  _createClass(ServiceQuestionElement, [{
    key: 'onAnswer',
    value: function onAnswer(event) {
      var answer = event.target.checked;
      this.props.answerQuestion(this.props.service.Id, this.props.question.Id, answer);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: 'line'
      }, _react2.default.createElement('div', {
        className: 'txt'
      }, _react2.default.createElement('p', null, this.props.question.Text)), _react2.default.createElement('div', {
        className: 'right'
      }, _react2.default.createElement('span', {
        className: 'switch'
      }, _react2.default.createElement('input', {
        type: 'checkbox',
        id: this.id,
        checked: this.props.isAnswered,
        onChange: this.onAnswer
      }), _react2.default.createElement('label', {
        htmlFor: this.id
      }, _react2.default.createElement('span', null)))));
    }
  }]);

  return ServiceQuestionElement;
}(_react2.default.Component);

ServiceQuestionElement.propTypes = {
  answerQuestion: _propTypes2.default.func.isRequired,
  isAnswered: _propTypes2.default.bool.isRequired,
  question: _propTypes2.default.object.isRequired,
  service: _propTypes2.default.object.isRequired
};

var ServiceElement = function (_React$Component2) {
  _inherits(ServiceElement, _React$Component2);

  function ServiceElement(props) {
    _classCallCheck(this, ServiceElement);

    var _this2 = _possibleConstructorReturn(this, (ServiceElement.__proto__ || Object.getPrototypeOf(ServiceElement)).call(this, props));

    _this2.state = {
      isSelected: props.isSelected,
      modal: false,
      id: _underscore2.default.uniqueId("service-")
    };
    return _this2;
  }

  _createClass(ServiceElement, [{
    key: 'getPriceLabel',
    value: function getPriceLabel(service) {
      if (this.props.formData.initialData.hidePrices) return "";
      return service.Price > 0 ? (0, _currency.currencyConverter)(service.Price) : 'Preis auf Anfrage';
    }
  }, {
    key: 'openModal',
    value: function openModal() {
      this.setState({
        modal: true
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({
        modal: false
      });
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      this.setState({
        isSelected: !this.state.isSelected
      });
    }
  }, {
    key: 'getParent',
    value: function getParent() {
      return document.querySelector('#otr');
    }
  }, {
    key: 'renderQuestions',
    value: function renderQuestions() {
      var selectors = [];

      if (!this.state.isSelected) {
        return;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.props.service.Questions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var question = _step.value;
          var isAnswered = this.props.answers.hasOwnProperty(this.props.service.Id) && this.props.answers[this.props.service.Id].hasOwnProperty(question.Id);
          selectors.push(_react2.default.createElement(ServiceQuestionElement, _extends({
            key: question.Id
          }, this.props, {
            question: question
          }, {
            isAnswered: isAnswered
          })));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return selectors;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var imageUrl = this.props.service.ImageId ? _config2.default.getKey("imageUrl") + this.props.service.ImageId : _slIcon_blank2.default;
      return _react2.default.createElement('div', {
        className: 'group'
      }, _react2.default.createElement('div', {
        className: 'line'
      }, _react2.default.createElement('div', {
        className: 'txt'
      }, _react2.default.createElement('div', {
        className: 'img icon'
      }, _react2.default.createElement('img', {
        src: imageUrl
      })), _react2.default.createElement('p', null, this.props.service.Name, _react2.default.createElement('span', {
        className: 'price'
      }, this.getPriceLabel(this.props.service)), _react2.default.createElement('span', null, this.props.service.Subtitle))), _react2.default.createElement('div', {
        className: 'right'
      }, _react2.default.createElement('a', {
        className: 'info',
        onClick: this.openModal.bind(this)
      }), _react2.default.createElement(_reactModal2.default, {
        className: 'myModal',
        overlayClassName: 'myOverlay',
        parentSelector: this.getParent,
        isOpen: this.state.modal,
        contentLabel: 'Modal'
      }, _react2.default.createElement(ServiceOverlay, {
        service: this.props.service,
        hidePrices: this.props.formData.initialData.hidePrices,
        onClose: this.closeModal.bind(this)
      })), _react2.default.createElement('span', {
        className: 'switch'
      }, _react2.default.createElement('input', {
        type: 'checkbox',
        id: this.state.id,
        checked: this.state.isSelected,
        onChange: this.toggle.bind(this),
        onClick: function onClick() {
          return _this3.props.selectService();
        }
      }), _react2.default.createElement('label', {
        htmlFor: this.state.id
      }, _react2.default.createElement('span', null))))), this.renderQuestions());
    }
  }]);

  return ServiceElement;
}(_react2.default.Component);

ServiceElement.propTypes = {
  service: _propTypes2.default.object.isRequired,
  selectService: _propTypes2.default.func.isRequired,
  isSelected: _propTypes2.default.bool.isRequired,
  answers: _propTypes2.default.object.isRequired,
  formData: _propTypes2.default.object
};

var ServiceGroup = function (_React$Component3) {
  _inherits(ServiceGroup, _React$Component3);

  function ServiceGroup(props) {
    _classCallCheck(this, ServiceGroup);

    var _this4 = _possibleConstructorReturn(this, (ServiceGroup.__proto__ || Object.getPrototypeOf(ServiceGroup)).call(this, props));

    var groupOpen = false;

    for (var selectId in _this4.props.selectors) {
      groupOpen = _this4.props.selectors[selectId].isSelected ? true : groupOpen;
    }

    _this4.state = {
      isOpen: groupOpen,
      id: _underscore2.default.uniqueId("group-")
    };
    return _this4;
  }

  _createClass(ServiceGroup, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var imageUrl = this.props.serviceGroup.ImageId ? _config2.default.getKey("imageUrl") + this.props.serviceGroup.ImageId : _slIcon_blank2.default;
      var selectors = [];

      for (var selectId in this.props.selectors) {
        var select = this.props.selectors[selectId];
        var service = select.service;
        selectors.push(_react2.default.createElement(ServiceElement, _extends({}, select.props, {
          service: service
        }, {
          key: service.Id,
          selectService: select.selectService,
          answerQuestion: select.answerQuestion,
          isSelected: select.isSelected,
          answers: select.answers
        })));
      }

      var groupVisibilty = (0, _classnames2.default)({
        "closeGroup": this.state.isOpen,
        "openGroup": !this.state.isOpen
      });
      var groupArrow = (0, _classnames2.default)({
        "showGroup": this.state.isOpen,
        "hideGroup": !this.state.isOpen
      });
      return _react2.default.createElement('div', {
        className: 'group ServiceGroup'
      }, _react2.default.createElement('div', {
        className: 'line',
        onClick: this.toggle.bind(this)
      }, _react2.default.createElement('div', {
        className: 'txt'
      }, _react2.default.createElement('div', {
        className: 'img icon'
      }, _react2.default.createElement('img', {
        src: imageUrl
      })), _react2.default.createElement('p', null, this.props.serviceGroup.Name)), _react2.default.createElement('div', {
        className: 'right'
      }, _react2.default.createElement('a', {
        className: groupVisibilty
      }))), _react2.default.createElement('div', {
        className: groupArrow
      }, selectors, _react2.default.createElement('div', {
        className: 'clear'
      })));
    }
  }]);

  return ServiceGroup;
}(_react2.default.Component);

ServiceGroup.propTypes = {
  serviceGroup: _propTypes2.default.object.isRequired
};

var ServiceSelector = function (_React$Component4) {
  _inherits(ServiceSelector, _React$Component4);

  function ServiceSelector(props) {
    _classCallCheck(this, ServiceSelector);

    var _this5 = _possibleConstructorReturn(this, (ServiceSelector.__proto__ || Object.getPrototypeOf(ServiceSelector)).call(this, props));

    _this5.state = {
      serviceIds: props.serviceIds,
      isFormValid: false,
      answers: props.answers
    };
    _this5.onAnswerQuestion = _this5.onAnswerQuestion.bind(_this5);
    return _this5;
  }

  _createClass(ServiceSelector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.loadServices();
      this.validateForm();
    }
  }, {
    key: 'getFormData',
    value: function getFormData() {
      return {
        stepId: "service",
        formData: {
          serviceIds: this.state.serviceIds,
          answers: this.state.answers
        }
      };
    }
  }, {
    key: 'hasExceededMaxDuration',
    value: function hasExceededMaxDuration() {
      var maxDuration = this.props.maxTimePerBooking;
      var duration = 0;
      this.state.services.forEach(function (service) {
        return duration += service.Duration;
      });
      return duration > maxDuration;
    }
  }, {
    key: 'onSelectService',
    value: function onSelectService(service) {
      var serviceIds = this.state.serviceIds;

      if (serviceIds.indexOf(service.Id) !== -1) {
        serviceIds = _underscore2.default.without(serviceIds, service.Id);
      } else {
        serviceIds.push(service.Id);
      }

      this.setState({
        serviceIds: serviceIds
      }, this.validateForm);
    }
  }, {
    key: 'onAnswerQuestion',
    value: function onAnswerQuestion(serviceId, questionId, answer) {
      var answers = this.state.answers;

      if (answer) {
        if (!answers[serviceId]) answers[serviceId] = {};
        answers[serviceId][questionId] = answer;
      } else {
        delete answers[serviceId][questionId];
      }

      this.setState({
        answers: answers
      });
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      var wasValid = this.state.isFormValid;
      var isValid = this.state.serviceIds.length > 0;

      if (wasValid !== isValid) {
        this.setState({
          isFormValid: isValid
        });
      }

      if (isValid) {
        this.props.enableSubmit();
      } else {
        this.props.disableSubmit();
      }
    }
  }, {
    key: 'renderServiceSelectors',
    value: function renderServiceSelectors() {
      var _this6 = this;

      var selectors = [];

      var _loop = function _loop(serviceId) {
        var service = _this6.props.services[serviceId];
        var b = _this6.state.serviceIds.indexOf(serviceId) !== -1;

        if (!service.ServiceGroupId) {
          selectors.push(_react2.default.createElement(ServiceElement, _extends({}, _this6.props, {
            service: service
          }, {
            key: serviceId,
            selectService: function selectService() {
              return _this6.onSelectService(service);
            },
            answerQuestion: _this6.onAnswerQuestion,
            isSelected: b,
            answers: _this6.state.answers
          })));
        }
      };

      for (var serviceId in this.props.services) {
        _loop(serviceId);
      }

      return selectors;
    }
  }, {
    key: 'renderServiceGroups',
    value: function renderServiceGroups() {
      var _this7 = this;

      var groups = [];

      for (var serviceGroupId in this.props.serviceGroups) {
        var serviceGroup = this.props.serviceGroups[serviceGroupId];
        var selectors = [];

        var _loop2 = function _loop2(serviceId) {
          var service = _this7.props.services[serviceId];
          var b = _this7.state.serviceIds.indexOf(serviceId) !== -1;

          if (service.ServiceGroupId === serviceGroup.Id) {
            selectors.push({
              props: _this7.props,
              service: service,
              selectService: function selectService() {
                return _this7.onSelectService(service);
              },
              answerQuestion: _this7.onAnswerQuestion,
              isSelected: b,
              answers: _this7.state.answers
            });
          }
        };

        for (var serviceId in this.props.services) {
          _loop2(serviceId);
        }

        groups.push(_react2.default.createElement(ServiceGroup, _extends({}, this.props, {
          serviceGroup: serviceGroup
        }, {
          selectors: selectors
        }, {
          key: serviceGroupId
        })));
      }

      return groups;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null, _react2.default.createElement('div', {
        className: 'sub'
      }, 'Auswahl Service'), this.props.isLoadingServices && _react2.default.createElement(_reactSpinkit2.default, {
        name: 'line-scale',
        fadeIn: 'quarter'
      }), this.props.loadServicesError !== "" && _react2.default.createElement('p', null, 'Es ist ein Fehler aufgetreten: ', this.props.loadServicesError), !Object.keys(this.props.services).length && !this.props.isLoadingServices && _react2.default.createElement('p', null, 'Keine Services gefunden'), this.renderServiceGroups(), this.renderServiceSelectors());
    }
  }]);

  return ServiceSelector;
}(_react2.default.Component);

ServiceSelector.propTypes = {
  loadServices: _propTypes2.default.func.isRequired,
  isLoadingServices: _propTypes2.default.bool.isRequired,
  loadServicesError: _propTypes2.default.string.isRequired,
  serviceGroups: _propTypes2.default.object,
  services: _propTypes2.default.object.isRequired,
  serviceIds: _propTypes2.default.array.isRequired,
  answers: _propTypes2.default.object.isRequired,
  maxTimePerBooking: _propTypes2.default.number.isRequired
};
exports.default = (0, _formStep2.default)(ServiceSelector);